import { useContext } from 'react';

import { StaticRouterContext } from './context';
import type { StaticRouterContextData } from './types';

export function useStaticRouterContext(): StaticRouterContextData | undefined {
	return useContext(StaticRouterContext);
}
